import { Pipe, PipeTransform } from "@angular/core";
import { differenceInHours, differenceInMinutes, differenceInSeconds, formatDistanceToNow } from 'date-fns';

@Pipe({
    name: 'timeago',
    pure: false
})
export class TimeagoPipe implements PipeTransform {
    transform(date: string): string {
        if (!date) {
            return '';
        }
        const time = new Date(date);
        const secondsAgo = differenceInSeconds(new Date(), time);
        if (secondsAgo < 60) return 'Just now';

        const minutes = differenceInMinutes(new Date(), time);
        if (minutes < 60) return `${minutes} ${minutes === 1 ? 'min' : 'mins'} ago`;

        const hours = differenceInHours(new Date(), time);
        if (hours < 24) return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;

        return formatDistanceToNow(time, { addSuffix: true });
    }
}